<div class="page-container gap-24">
  <div class="page-title">Meine Bibliothek</div>
  <app-table-header-navigation
    [slides]="cardSlides"
    [isLoading]="loadingLibrary"
    (cardClicked)="onCardClicked($event)"></app-table-header-navigation>
  <app-file-manager
    [isUserLibrary]="true"
    [allowUpload]="false"
    [allowDelete]="false"
    [seminarCategory]="selectedCategory"
    [listView]="true"
    [isAdminView]="false"
    (filesLoaded)="onLibraryLoaded()"
    [enableSeminarFilter]="true"
    [seminarFilterOptions]="seminarFilterOptions"></app-file-manager>
</div>
